import { type WorkspaceAgentMessage } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentMessage';
import { getLatestWorkspaceAgentUserMessage } from '~/components/v2/components/workspace/workspace-agent-panel/utils/getLatestWorkspaceAgentUserMessage';

/** True when catch-up (or a live stream) already placed an assistant reply after the latest user turn. */
export const hasWorkspaceAgentAssistantReplyAfterLatestUserMessage = (messages: WorkspaceAgentMessage[]): boolean => {
  const latestUserMessage = getLatestWorkspaceAgentUserMessage(messages);

  if (!latestUserMessage) {
    return false;
  }

  return messages.some((message) => message.role === 'assistant' && message.sequence > latestUserMessage.sequence);
};

export type ShouldClearWorkspaceAgentAwaitingRunStartParams = {
  activeRunId: string | null;
  messages: WorkspaceAgentMessage[];
};

/**
 * Unlock send once WSS has a live run (Stop then tracks that run) or REST catch-up already has the
 * reply. Do not wait for list `status !== processing` — with a quiet socket that flag can stay true
 * after the turn is on screen, which would leave Stop stuck.
 */
export const shouldClearWorkspaceAgentAwaitingRunStart = ({
  activeRunId,
  messages,
}: ShouldClearWorkspaceAgentAwaitingRunStartParams): boolean =>
  activeRunId !== null || hasWorkspaceAgentAssistantReplyAfterLatestUserMessage(messages);
